import { signal } from '@preact/signals';
import type { KeyValue } from '../../net/progress';
import type { AudioManager } from './manager';
import { DEFAULT_AUDIO_SETTINGS, saveAudioSettings, type AudioSettings } from './settings';

/*
 * État audio lu par l'interface (Hub, bouton muet du HUD), sans dépendance à Phaser : les panneaux Preact
 * (et leurs tests sous jsdom) l'importent sans charger le moteur. Le gestionnaire est branché par `installAudio`.
 */

/** Réglages audio visibles par l'interface (Hub, bouton muet du HUD). */
export const audioState = { settings: signal<AudioSettings>({ ...DEFAULT_AUDIO_SETTINGS }) };

let manager: AudioManager | null = null;
let kv: KeyValue | null = null;

export const getAudio = (): AudioManager | null => manager;

/** Branche le gestionnaire audio et le stockage des réglages (null pour débrancher). */
export function setAudioBackend(m: AudioManager | null, storage: KeyValue | null): void { manager = m; kv = storage; }

/** Modifie les réglages (curseurs, muet), les mémorise et les applique immédiatement. */
export function updateAudioSettings(patch: Partial<AudioSettings>): AudioSettings {
  const next = { ...audioState.settings.value, ...patch };
  audioState.settings.value = next;
  if (kv) saveAudioSettings(kv, next);
  manager?.apply(next);
  return next;
}
